import React, { useState, useEffect } from 'react';
import Confetti from 'react-confetti';
import { useWindowSize } from 'react-use';

const ConfettiAnimation = () => {
    const [showConfetti, setShowConfetti] = useState(true);  // Trigger confetti animation immediately
    const { width, height } = useWindowSize();

    useEffect(() => {
        // Set interval to continuously trigger confetti every 10 seconds
        const interval = setInterval(() => {
            setShowConfetti(true); // Trigger confetti every 10 seconds
        }, 10000);

        // Cleanup interval on unmount
        return () => clearInterval(interval);
    }, []);

    // Multiple confetti sources
    const confettiSources = [
        { x: 0, y: 0, w: width, h: 10 },        // Bottom-left confetti source
        // { x: width / 2, y: height / 2, w: 100, h: 10 }, // Center burst
        // { x: width, y: height / 3, w: 50, h: 10 },    // Top-right burst
        // { x: 0, y: height / 3, w: 50, h: 10 },    // Top-right burst
    ];

    return showConfetti ? (
        <>
            {confettiSources.map((source, index) => (
                <Confetti
                    key={index}
                    width={width}
                    height={height}
                    numberOfPieces={600}
                    confettiSource={source}
                    gravity={0.03}
                    run={true}
                    recycle={true}
                />
            ))}
        </>
    ) : null;
};

export default ConfettiAnimation;
